import { useState } from 'react'
import './musicianName.css'
import { Done } from '@mui/icons-material'
import { Input, Modal } from 'antd'
import { useAtom } from 'jotai'
import userClient from '../../../Api/Lirari/Clients/userClient'
import { useAuth0 } from '@auth0/auth0-react'
import { useParams } from 'react-router-dom'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import { unauthenticatedUserAtom } from '../../../State/Musician/unauthenticatedUserAtom'

const MusicianName = ({ editMode }: { editMode: boolean }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [unauthenticatedUser] = useAtom(unauthenticatedUserAtom)

  const { isAuthenticated, getAccessTokenSilently } = useAuth0()
  const [myUser, setMyUser] = useAtom(myUserAtom)

  const { uid: userId } = useParams()

  const userProfile = userId == myUser.id ? myUser : undefined

  const showModal = () => {
    setIsModalOpen(true)
  }

  const nameModal = (
    <Modal centered open={isModalOpen} closable={false} footer={[]}>
      <div className="flex flex-col items-center">
        <Input
          variant="borderless"
          className="text-input"
          value={myUser.firstName}
          placeholder="First Name"
          onChange={(e) => setMyUser({ ...myUser, firstName: e.target.value, lastName: myUser.lastName })}
        />
        <Input
          variant="borderless"
          className="text-input"
          value={myUser.lastName}
          placeholder="Last Name"
          onChange={(e) => setMyUser({ ...myUser, firstName: myUser.firstName, lastName: e.target.value })}
        />
        <button
          className="flex p-0 mt-2.5 justify-center items-center size-12 rounded-full bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black"
          onClick={async () => {
            if (isAuthenticated) {
              await userClient.updateUser(
                userId!,
                { firstName: myUser.firstName, lastName: myUser.lastName },
                await getAccessTokenSilently({
                  authorizationParams: {
                    scope: 'user:all',
                  },
                }),
              )
            }
            setIsModalOpen(false)
          }}
        >
          <Done />
        </button>
      </div>
    </Modal>
  )

  return (
    <div
      className={`${editMode ? 'cursor-pointer' : ''} flex flex-col lg:justify-self-end lg:justify-end lg:mb-[3vh] leading-none`}
      onClick={() => (editMode && !isModalOpen ? showModal() : null)}
    >
      <p className="musician-name lg:justify-start justify-center" style={{ fontSize: 35 }}>
        {
          userProfile && userId === userProfile.id
            ? userProfile.firstName // Logged in and at my profile
            : userId
              ? unauthenticatedUser.firstName // Viewing a profile without login or logged in and not at my profile
              : 'Saed' // Not in a user page, in example profile
        }
      </p>
      <div className="flex flex-row items-center lg:justify-start justify-center">
        <p className="musician-name" style={{ fontSize: 35 }}>
          {
            userProfile && userId === userProfile.id
              ? userProfile.lastName // Logged in and at my profile
              : userId
                ? unauthenticatedUser.lastName // Viewing a profile without login or logged in and not at my profile
                : 'Diab' // Not in a user page, in example profile
          }
        </p>
      </div>
      {nameModal}
    </div>
  )
}

export default MusicianName
